import React from "react";
import { Paper, Box, Typography, alpha, useTheme } from "@mui/material";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

interface EmptyTranscriptsStateProps {
  hasActiveFilters: boolean;
}

export const EmptyTranscriptsState: React.FC<EmptyTranscriptsStateProps> = ({
  hasActiveFilters,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 4, md: 6 },
        textAlign: "center",
        bgcolor: alpha(theme.palette.background.paper, 0.5),
        borderRadius: 3,
        border: `2px dashed ${alpha(theme.palette.divider, 0.3)}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 400,
      }}
    >
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 3,
        }}
      >
        <RecordVoiceOverIcon
          sx={{
            fontSize: 50,
            color: alpha(theme.palette.primary.main, 0.6),
          }}
        />
      </Box>
      <Typography
        variant="h5"
        fontWeight={600}
        color="text.primary"
        gutterBottom
      >
        {hasActiveFilters
          ? "No matching transcripts"
          : "No transcripts yet"}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 450, mx: "auto" }}
      >
        {hasActiveFilters
          ? "Try a different search term."
          : "Once your bodycam evidence is transcribed, the transcripts will appear here."}
      </Typography>
    </Paper>
  );
};
